import { render } from "./FpSection.vue?vue&type=template&id=5e5bc407"
import script from "./FpSection.vue?vue&type=script&lang=js"
export * from "./FpSection.vue?vue&type=script&lang=js"

import _style_0 from "./FpSection.vue?vue&type=style&index=0&id=5e5bc407&inline&lang=css"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]]])

export default __exports__